/**
 * [Financial].[Order].[ShippingTrackUrl] nem sempre guarda uma URL: as entregas da frota própria
 * gravam o literal 'Viver Organizer' nessa coluna. Renderizar isso como link produz um href
 * quebrado, então só tratamos como rastreio o que de fato é um endereço http(s).
 */
export const isTrackingLink = (url?: string | null): url is string => {
  if (!url) return false;
  const trimmed = url.trim();
  return trimmed.startsWith('http://') || trimmed.startsWith('https://');
};
